/**
 * PERF FIX: Tắt preloadImages mặc định của Swiper 8.
 * Swiper 8 mặc định preloadImages=true → ép tải img.src (bản fallback 720/940/full-width)
 * cho MỌI slide, trong khi trình duyệt đã tự chọn bản đúng kích thước từ srcset.
 * Hậu quả: mọi ảnh trong slider (slideshow, product cards, categories...) bị tải 2 lần (~2.5MB/trang chủ).
 * File này phải load ngay SAU swiper-bundle.min.js và TRƯỚC các script section (defer giữ đúng thứ tự đó).
 */
if (window.Swiper && Swiper.extendDefaults) {
  Swiper.extendDefaults({ preloadImages: false, updateOnImagesReady: false });
}
